import { FC, useCallback } from "react";
import { ListItemText, MenuItem } from "@mui/material";
import { DimensionIcon } from "@/components/pages/dimensions/components/icons/DimensionIcon";
import { DimensionWithCosts } from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

interface BillingExplorerFilterTreeAddToDimensionPopoverItemProps
  extends DimensionWithCosts {
  onClick(data: DimensionWithCosts): void;
}

export const BillingExplorerFilterTreeAddToDimensionPopoverItem: FC<
  BillingExplorerFilterTreeAddToDimensionPopoverItemProps
> = ({ onClick, name, id, ...props }) => {
  const clickHandler = useCallback(() => {
    onClick({
      ...props,
      id,
      name,
    });
  }, [onClick, props, id, name]);

  return (
    <MenuItem value={id} onClick={clickHandler}>
      <DimensionIcon
        color="action"
        fontSize="small"
        sx={{
          mr: 1.5,
        }}
      />
      <ListItemText>
        <TypographyWithTooltip title={name} />
      </ListItemText>
    </MenuItem>
  );
};
